import {  HttpLink } from "apollo-link-http";
import ApolloClient from "apollo-client";
import { InMemoryCache, IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import GeladaRefreshToken from "./geladaRefreshToken";

import introspectionQueryResultData from '../schema/fragmentTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});



export default function GeladaClient (requiredToken:boolean=true,customBuild:string=""){

  
        var buildGuid = process.env.REACT_APP_PROJECT_ID===undefined ? "" : process.env.REACT_APP_PROJECT_ID;
        if(buildGuid==="")
          buildGuid=customBuild;
        const cache = new InMemoryCache({ fragmentMatcher });
        const link = new HttpLink({
          uri: process.env.REACT_APP_GELADA_API_URL,
          headers:{
            Authorization: requiredToken? GeladaRefreshToken() : "",
            Custom_build_guid:buildGuid,
            'Content-Type': 'application/graphql',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
          }
        });

        const client = new ApolloClient({
          cache: cache,
          link: link,

          name: 'react-web-client',
          version: '1.3',
          queryDeduplication: false,
          defaultOptions: {
            watchQuery: {
              fetchPolicy: 'cache-and-network',
            },
          },
        });
     
      
      return client;
}